'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  config: {
    theme: 'theme-background-color-white',
    type: 'static'
  },
  content: {
    headline: {
      text: 'Fewer than 25 characters fit on one line in mobile.'
    },
    paragraph: {
      text: 'Fewer than 100 characters total to equal less than 3 lines in mobile.'
    },
    features: {
      centerImage: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/na/ca/consumer/choose-how-you-pay/P2P-Checkout-presentation_fr.gif',
        alt: 'Features'
      },
      tiles: [{
        content: {
          iconImage: {
            src: 'https://www.paypalobjects.com/digitalassets/c/EMEA/landing_page/landing-pages/39202_passport_refresh_2018_v2/1_overview/Icon_5.png',
            alt: 'laptop'
          },
          headline: {
            text: '25 chars or less'
          },
          paragraph: {
            text: 'paragraph - 50 chars or less'
          }
        }
      }, {
        content: {
          iconImage: {
            src: 'https://www.paypalobjects.com/digitalassets/c/EMEA/landing_page/landing-pages/39202_passport_refresh_2018_v2/1_overview/Icon_5.png',
            alt: 'people'
          },
          headline: {
            text: '25 chars or less'
          },
          paragraph: {
            text: 'paragraph - 50 chars or less'
          }
        }
      }, {
        content: {
          iconImage: {
            src: 'https://www.paypalobjects.com/digitalassets/c/EMEA/landing_page/landing-pages/39202_passport_refresh_2018_v2/1_overview/Icon_5.png',
            alt: 'money'
          },
          headline: {
            text: '25 chars or less'
          },
          paragraph: {
            text: 'paragraph - 50 chars or less'
          }
        }
      }, {
        content: {
          iconImage: {
            src: 'https://www.paypalobjects.com/digitalassets/c/EMEA/landing_page/landing-pages/39202_passport_refresh_2018_v2/1_overview/Icon_5.png',
            alt: 'stopwatch'
          },
          headline: {
            text: '25 chars or less'
          },
          paragraph: {
            text: 'paragraph - 50 chars or less'
          }
        }
      }]
    },
    cta: {
      text: 'Fewer Than 29 Characters Max',
      href: '#',
      'data-pa-click': 'cta|CTA Text',
      target: '_self'
    },
    hatchText: {
      text: 'Fewer than 34 characters per line'
    },
    mediaButton: {
      text: 'This is Media Button',
      'data-video-id': 'rquuf4XfwLA'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/product-features/props/default.js
// module id = 1132
// module chunks = 4